module.exports = __webpack_public_path__ + "img/制御工学3_10_3.bf7c1902.png";